var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"max-width":"600","has-padding":false},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{key:"integration-report",staticClass:"wrapper"},[_c('div',{staticClass:"errors"},_vm._l((_vm.logs),function(log,index){return _c('h6',{key:index},[_vm._v(_vm._s(log))])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }